import React, { useEffect } from 'react';

import classnames from 'classnames/bind';

import { useGetAllDocumentsAdmin } from '@SERVICES';

import useGlobalPermissions from '@HOOKS/useGlobalPermissions';
import useNewDocumentModal from '@HOOKS/store/modals/useNewDocumentModal';
import useDeleteDocumentModal from '@HOOKS/store/modals/useDeleteDocumentModal';

import DataLoader from '@COMPONENTS/SHARED/DataLoader';
import Content from '@PAGES/admin/documents-list/components/Content';

import styles from './DocumentsList.module.scss';

const cx: CX = classnames.bind(styles);

function DocumentsListPage() {
    const {
        data: documentsData = [], isLoading, isError, error,
    } = useGetAllDocumentsAdmin();

    const {
        canCreateDocuments,
    } = useGlobalPermissions();

    const {
        actions: newDocumentModalActions,
    } = useNewDocumentModal(() => true);

    const {
        actions: deleteDocumentModalActions,
    } = useDeleteDocumentModal(() => true);

    useEffect(() => () => {
        newDocumentModalActions.close();
        deleteDocumentModalActions.close();
    }, [
        newDocumentModalActions,
        deleteDocumentModalActions,
    ]);

    return (
        <div className={cx('page')}>
            <div className="container max-constraint center">
                {/* Modern Page Header */}
                <div className={cx('page-header')}>
                    <div className={cx('header-content')}>
                        <div className={cx('header-text')}>
                            <h1 className={cx('page-title')}>Document Templates</h1>
                            <p className={cx('page-subtitle')}>
                                Manage and organize your document templates. Create new templates or edit existing ones to streamline your document generation process.
                            </p>
                        </div>
                        <div className={cx('header-actions')}>
                            <button
                                type="button"
                                className={cx('add-document-btn', {
                                    disabled: !canCreateDocuments,
                                })}
                                onClick={() => newDocumentModalActions.open()}
                                disabled={!canCreateDocuments}
                            >
                                <span className={cx('btn-icon')}>+</span>
                                New Document
                            </button>
                        </div>
                    </div>
                </div>

                <DataLoader
                    isLoading={isLoading}
                    isError={isError}
                    error={error}
                >
                    <Content documentsData={documentsData} />
                </DataLoader>
            </div>
        </div>
    );
}

export default DocumentsListPage;
